import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class RatingsRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  cancelRating(requestVO) {
    throw new Error('[RatingsRepository#cancelRating] must be implemented')
  }
}
